(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7965],{

/***/ 5317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96781);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10682);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


 // import CustomIframe from './CustomIframe';





function Tally(_ref) {
  var masterConfig = _ref.masterConfig,
      showExitTally = _ref.showExitTally,
      showResultTally = _ref.showResultTally,
      stateName = _ref.stateName;
  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_1__/* .useWindowSize */ .iP)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [showExitTally != false && (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u090F\u0917\u094D\u095B\u093F\u091F \u092A\u094B\u0932"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL, "&state_name=").concat(stateName),
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exitpolltally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "result-page  ",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
            style: {
              fontSize: "27px",
              color: "#D9368B",
              fontWeight: "800"
            },
            children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u090F\u0917\u094D\u095B\u093F\u091F \u092A\u094B\u0932"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
              scrolling: "no",
              src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exittally_URL, "&state_name=").concat(stateName),
              width: "100%",
              height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Exitpolltally_height_web
            })
          })]
        })
      })
    }), showResultTally != false && (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0926\u093F\u0932\u094D\u0932\u0940 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL, "&state_name=").concat(stateName),
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "result-page-big",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
            style: {
              fontSize: "27px",
              color: "#D9368B",
              fontWeight: "800"
            },
            children: "\u0926\u093F\u0932\u094D\u0932\u0940 \u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
              scrolling: "no",
              src: !stateName ? "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL) : "".concat(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_URL, "&state_name=").concat(stateName),
              width: "100%",
              height: size.width != 768 && size.width <= 1000 ? masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_tab_internal : masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Resulttally_height_web // height={(size.width != 768 && size.width <= 1000 )? masterConfig.Maharashtra_Resulttally_height_tab_internal   :
              //   masterConfig
              //     .Maharashtra_Resulttally_height_web
              // }
              // height={(window.innerWidth != 768 && window.innerWidth <= 1000) ? masterConfig?.Maharashtra_Resulttally_height_tab_internal :  masterConfig?.Maharashtra_Resulttally_height_web}

            })
          })]
        })
      })
    }), (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0909\u092A\u091A\u0941\u0928\u093E\u0935 \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally_URL,
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Bypoll_Resulttally_height_mobile
          })
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "result-page-big",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          style: {
            fontSize: "27px",
            color: "#D9368B",
            fontWeight: "800"
          },
          children: "\u0909\u092A\u091A\u0941\u0928\u093E\u0935 \u0930\u093F\u091C\u0932\u094D\u091F"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("iframe", {
            scrolling: "no",
            src: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.BypollResulttally_URL,
            width: "100%",
            height: masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.Bypoll_Resulttally_height_web
          })
        })]
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (Tally);

/***/ }),

/***/ 51253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Trending; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10682);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96781);
/* harmony import */ var localization_i8intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54269);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2962);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39712);
/* harmony import */ var api_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9041);
/* harmony import */ var components_tally_Tally__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5317);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);











 // import { FormattedMessage } from "react-intl";




var __N_SSP = true;
function Trending(props) {
  var _useContext, _electionTopicData$, _electionTopicData$2, _electionTopicData$3, _electionTopicData$4, _electionTopicData$5, _electionTopicData$6;

  var mainUrl = "all";
  var electionsData = (_useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_7__/* .MasterConfigContext */ .d)) === null || _useContext === void 0 ? void 0 : _useContext[props.masterKey];
  console.log("Checking data", electionsData);
  var stateNameEnglish = "Maharashtra";
  var stateNameHindi = "महाराष्ट्र";
  var metaKeyMaharashtra = "Maharashtra Assembly Election Schedule,Maharashtra Assembly Election Schedule,Maharashtra Assembly Election 2024,Maharashtra विधान सभा चुनाव 2024,महाराष्ट्र विधान सभा चुनाव  2024,महाराष्ट्र चुनाव अनुसूची 2024";

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      language = _useState[0],
      setLanguage = _useState[1];

  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_2__/* .useWindowSize */ .iP)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      electionTopicData = _useState2[0],
      setElectionTopicData = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)( /*#__PURE__*/(0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _dataFetched, _dataFetched$result;

    var dataFetched, datas;
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_11__/* .baseUrl */ .FH, "/web/postListByCategory/election?limit=5&skip=1&type=text,video,liveblog"));

          case 2:
            datas = _context.sent;
            _context.next = 5;
            return datas === null || datas === void 0 ? void 0 : datas.json();

          case 5:
            dataFetched = _context.sent;
            dataFetched = (_dataFetched = dataFetched) === null || _dataFetched === void 0 ? void 0 : (_dataFetched$result = _dataFetched.result) === null || _dataFetched$result === void 0 ? void 0 : _dataFetched$result.entities;
            setElectionTopicData(dataFetched);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setLanguage((0,localization_i8intl__WEBPACK_IMPORTED_MODULE_3__/* .getLanguage */ .G3)());
    setTimeout(function () {
      window.googletag = window.googletag || {
        cmd: []
      };

      if (window.screen.width > 600) {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_728x90", [[728, 90], [970, 250], [970, 90]], "div-gpt-ad-1701945163318-0").addService(googletag.pubads());
          googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_1_728x90", [728, 90], "div-gpt-ad-1701945220410-1").addService(googletag.pubads()); //  googletag.defineOutOfPageSlot('/1007232/Lallantop_Mobile_HP_Mweb_Interstitial',googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());

          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      } else {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_ATF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-0").addService(googletag.pubads());
          googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_1_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-1").addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", [""]);
          googletag.pubads().setTargeting("Keywords", "");
          googletag.enableServices();
        });
      }

      googletag.pubads().refresh(); // console.log("apstag", typeof apstag);
      // if (typeof apstag !== "undefined") {
      //   apstag.init({
      //     pubID: "7f0bbd82-5a13-48ec-9950-fcb028b1546c",
      //     adServer: "googletag",
      //     bidTimeout: 2e3,
      //   });
      //   // request the bids for the four googletag slots
      //   apstag.fetchBids(
      //     {
      //       slots: [
      //       ],
      //     },
      //     function (bids) {
      //       // set apstag bids, then trigger the first request to GAM
      //       googletag.cmd.push(function () {
      //         apstag.setDisplayBids();
      //         googletag.pubads().refresh();
      //       });
      //     }
      //   );
      // }
    }, 500);
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "http://schema.org/",
            "@type": "WebPage",
            name: "".concat(stateNameEnglish, " Assembly Election 2024 Schedule: ").concat(stateNameHindi, " \u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 \u0905\u0928\u0941\u0938\u0942\u091A\u0940"),
            description: "".concat(stateNameEnglish, " Vidhan Sabha Chunav 2024 Schedule : Find here all details related to ").concat(stateNameEnglish, " Assembly Elections 2024 Schedule (\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 2024 \u0905\u0928\u0941\u0938\u0942\u091A\u0940) like poll dates,\n                key candidates, election result date at The Lallantop"),
            keywords: "".concat(metaKeyMaharashtra),
            url: "".concat("https://www.thelallantop.com", "/election/maharashtra-assembly-chunav/schedule"),
            publisher: {
              "@type": "Organization",
              name: "The Lallantop",
              url: "https://www.thelallantop.com/",
              logo: {
                "@type": "ImageObject",
                url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
                width: 600,
                height: 60
              }
            }
          })
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [{
              "@type": "ListItem",
              position: 1,
              item: {
                "@id": "".concat("https://www.thelallantop.com/"),
                name: "Home"
              }
            }, {
              "@type": "ListItem",
              position: 2,
              item: {
                name: "Election",
                "@id": "".concat("https://www.thelallantop.com/", "election")
              }
            }, {
              "@type": "ListItem",
              position: 3,
              item: {
                name: "Assembly Election 2024",
                "@id": "".concat("https://www.thelallantop.com/", "election/maharashtra-assembly-chunav")
              }
            }, {
              "@type": "ListItem",
              position: 4,
              item: {
                name: "".concat((props === null || props === void 0 ? void 0 : props.state) === "maharashtra" ? "Maharashtra Assembly Election 2024 Schedule" : "Jammu and Kashmir Assembly Election 2024 Schedule"),
                "@id": "".concat("https://www.thelallantop.com", "/election/maharashtra-assembly-chunav/schedule")
              }
            }]
          })
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SiteNavigationElement",
            name: ["होम", "चुनाव", "न्यूज़", "एंटरटेनमेंट", "ऑडनारी", "टेक्नोलॉजी", "पड़ताल", "बिज़नेस", "लल्लनख़ास", "स्पोर्ट्स", "रंगरूट"],
            url: ["https://www.thelallantop.com/", "https://www.thelallantop.com/election", "https://www.thelallantop.com/news", "https://www.thelallantop.com/entertainment", "https://www.thelallantop.com/oddnaari", "https://www.thelallantop.com/technology", "https://www.thelallantop.com/factcheck", "https://www.thelallantop.com/business", "https://www.thelallantop.com/lallankhas", "https://www.thelallantop.com/sports", "https://www.thelallantop.com/education"]
          })
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("link", {
        rel: "preconnect",
        crossOrigin: "true",
        href: "https://static.chartbeat.com"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("script", {
        async: true,
        dangerouslySetInnerHTML: {
          __html: "\n            (function () {\n              var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});\n              _sf_async_config.uid = 60355;\n              _sf_async_config.domain = 'thelallantop.com';\n              _sf_async_config.useCanonical = true;\n              _sf_async_config.useCanonicalDomain = true;\n              _sf_async_config.sections = 'home'; \n              _sf_async_config.authors = '';\n              function loadChartbeat() {\n                  var e = document.createElement('script');\n                  var n = document.getElementsByTagName('script')[0];\n                  e.type = 'text/javascript';\n                  e.async = true;\n                  e.src = '//static.chartbeat.com/js/chartbeat.js';\n                  n.parentNode.insertBefore(e, n);\n              }\n              loadChartbeat();\n          })();\n       "
        },
        strategy: "afterInteractive",
        id: "chartbeat",
        type: "text/javascript"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_4__/* .NextSeo */ .PB, {
      title: "".concat(stateNameEnglish, " Assembly Election 2024 Schedule: ").concat(stateNameHindi, " \u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 \u0905\u0928\u0941\u0938\u0942\u091A\u0940 \n\n"),
      description: "".concat(stateNameEnglish, " Vidhan Sabha Chunav 2024 Schedule : Find here all details related to ").concat(stateNameEnglish, " Assembly Elections 2024 Schedule (\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 2024 \u0905\u0928\u0941\u0938\u0942\u091A\u0940) like poll dates,\nkey candidates, election result date at The Lallantop \n\n"),
      canonical: "".concat("https://www.thelallantop.com", "/election/maharashtra-assembly-chunav/schedule")
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("meta", {
      name: "keywords",
      content: "".concat(metaKeyMaharashtra)
    }), size.width > 500 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      children: size.width >= 600 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        style: {
          position: "relative",
          display: "flex",
          justifyContent: "center"
        },
        children: [router.asPath.includes("election") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
          style: {
            position: "relative"
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
            src: "/assets/images/election-background-3.png",
            style: {
              position: "relative",
              width: "100%",
              height: "298px"
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
            src: "/assets/images/left-election-top-2.png",
            width: "",
            height: "170px",
            style: {
              position: "absolute",
              bottom: "10px",
              left: "10px"
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
            src: router.asPath.includes("maharashtra-assembly") ? "/assets/images/right-election-top-2.png" : router.asPath.includes("jammu-kashmir-assembly") ? "/assets/images/jammu-kashmir.png" : "/assets/images/indian-map.png",
            width: "",
            height: "250px",
            style: {
              position: "absolute",
              bottom: "0",
              right: "0px"
            }
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
          align: "center",
          style: {
            position: router.asPath.includes("/election") ? "absolute" : "relative",
            top: router.asPath.includes("/election") ? "22px" : "0px"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
            className: "container-row py-2",
            align: "center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
              style: {
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
                marginBottom: "0px"
              },
              children: "Advertisement"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
              id: "div-gpt-ad-1701945163318-0",
              style: {
                minWidth: "300px",
                minHeight: "100px",
                display: "block !important",
                alignContent: "center",
                textAlign: "-webkit-center"
              },
              className: "ads-auto-resize",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("script", {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                  __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})"
                }
              })
            })]
          })
        })]
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      style: {
        position: "relative",
        width: "100%"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
        src: "/assets/images/election-background-mobile.png",
        style: {
          position: "relative",
          width: "100%",
          height: "auto"
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
        src: "/assets/images/election-left-mobile.png",
        width: "",
        height: "70px",
        style: {
          position: "absolute",
          bottom: "10px",
          left: "10px"
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
        src: router.asPath.includes("maharashtra-assembly") ? "/assets/images/right-election-top-2.png" : router.asPath.includes("jammu-kashmir-assembly") ? "/assets/images/jammu-kashmir.png" : "/assets/images/indian-map.png",
        width: "",
        height: "90px",
        style: {
          position: "absolute",
          bottom: "0",
          right: "0px"
        }
      })]
    }), size.width > 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      style: {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "white",
        width: "max-content",
        margin: "auto",
        gap: "68px",
        height: "80px",
        marginTop: "15px",
        borderRadius: "12px",
        padding: "0px 30px"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          // paddingTop: "1rem",
          gap: "8px",
          // cursor: "pointer",
          backgroundColor: "white",
          paddingLeft: "0px"
        } // onClick={() =>
        //   window.open("/election/lok-sabha-chunav-2024", "_self")
        // }
        ,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
          src: "/assets/images/assembly-chunav.png",
          width: "408.56px",
          height: "58.21px",
          style: {
            alignSelf: "center"
          }
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        "class": "divCategoriesSchedule2 snipcss-eqdpv",
        style: {
          margin: "0px 0px",
          // backgroundColor: "rgb(217, 54, 139)",
          paddingLeft: "15px",
          alignContent: "center"
        },
        children: props.breadCrump.map(function (item, index) {
          return electionsData[item.keyToShow] != false ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
            href: item.url,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
              children: item.displayText
            })
          }, index) : null;
        })
      })]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          paddingTop: "1rem",
          gap: "8px",
          // cursor: "pointer",
          paddingBottom: "1rem",
          backgroundColor: "white",
          marginTop: "10px"
        } // onClick={() =>
        //   window.open("/election/lok-sabha-chunav-2024", "_self")
        // }
        ,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
          src: "/assets/images/assembly-chunav.png",
          width: "240px",
          height: "auto",
          style: {
            alignSelf: "center"
          }
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        "class": "divCategoriesSchedule2 snipcss-eqdpv",
        style: {
          margin: "-1px 0px",
          backgroundColor: "white",
          paddingLeft: "15px",
          paddingBottom: "1rem",
          display: "flex",
          justifyContent: "center"
        },
        children: props.breadCrump.map(function (item, index) {
          return electionsData[item.keyToShow] != false ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
            href: item.url,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
              children: item.displayText
            })
          }, index) : null;
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("br", {}), size.width <= 768 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "container-row py-2",
      align: "center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          textAlign: "center",
          marginBottom: "0px"
        },
        children: "Advertisement"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        id: "div-gpt-ad-1701946028239-0",
        style: {
          minWidth: "300px",
          minHeight: "260px",
          display: "block !important",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        className: "ads-auto-resize",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("script", {
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
          }
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_tally_Tally__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      stateName: "maharashtra",
      masterConfig: electionsData
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("ul", {
      className: "breadcrumb party-wise-bc",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
          href: "/",
          passHref: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("a", {
            "aria-label": "Lallantop Home",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("i", {
              className: "icon-cat-home"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
              children: "Home"
            })]
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
          href: "/election",
          passHref: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
            "aria-label": "Lallantop Home",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
              children: "Election"
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("li", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
          children: "Maharashtra Election Schedule"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "lok-sabha-main",
      style: {
        paddingBottom: "50px"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h1", {
        children: "\u092E\u0939\u093E\u0930\u093E\u0937\u094D\u091F\u094D\u0930 \u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935 2024 \u0905\u0928\u0941\u0938\u0942\u091A\u0940"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "assembly-buttons",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          onClick: function onClick() {
            if ((props === null || props === void 0 ? void 0 : props.state) !== "maharashtra") {
              window.location.href = "/election/maharashtra-assembly-chunav/schedule";
            }
          },
          className: (props === null || props === void 0 ? void 0 : props.state) === "maharashtra" ? "assembly-buttons-btn-active" : "assembly-buttons-btn",
          children: "\u092E\u0939\u093E\u0930\u093E\u0937\u094D\u091F\u094D\u0930"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          onClick: function onClick() {
            if ((props === null || props === void 0 ? void 0 : props.state) === "maharashtra") {
              window.location.href = "/election/jharkhand-assembly-chunav/schedule";
            }
          },
          className: (props === null || props === void 0 ? void 0 : props.state) !== "maharashtra" ? "assembly-buttons-btn-active" : "assembly-buttons-btn",
          children: "\u091D\u093E\u0930\u0916\u0902\u0921"
        }), " "]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "schedule-card-box-election",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
          className: "schedule-card",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: "state-name",
            children: "\u092E\u0939\u093E\u0930\u093E\u0937\u094D\u091F\u094D\u0930"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("ul", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("li", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                children: "\u092B\u0947\u091C"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                children: "\u092B\u0947\u091C 1"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("li", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                children: "\u092E\u0924\u0926\u093E\u0928 \u0915\u0940 \u0924\u093E\u0930\u0940\u0916 :"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                children: "20 \u0928\u0935\u0902\u092C\u0930 2024"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("li", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                children: "\u092E\u0924\u0917\u0923\u0928\u093E \u0915\u0940 \u0924\u093E\u0930\u0940\u0916 :"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                children: "23 \u0928\u0935\u0902\u092C\u0930 2024"
              })]
            })]
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "electionYatra-outer-home",
        style: {
          width: "100% "
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
          className: "electionYatra-header",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
              src: "/assets/images/election-icon.png",
              width: "35px",
              height: "35px",
              alt: "election-icon"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
              style: {
                marginLeft: "10px"
              },
              children: "\u0935\u093F\u0927\u093E\u0928\u0938\u092D\u093E \u091A\u0941\u0928\u093E\u0935"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
            className: "election-aurDekhe",
            onClick: function onClick() {
              return router.push("/election");
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
              style: {
                marginRight: "10px"
              },
              children: "\u0914\u0930 \u0926\u0947\u0916\u0947\u0902 "
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
              src: "/assets/images/arrow.png",
              width: "10px",
              height: "10px"
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
          className: "electionYatra-columns",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
            className: "checkMobileOrNot",
            href: "".concat((_electionTopicData$ = electionTopicData[0]) === null || _electionTopicData$ === void 0 ? void 0 : _electionTopicData$.permalink),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
              className: "electionYatra-second election-mobile",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                className: "electionYatra-second-top",
                style: {
                  position: "relative"
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                  src: (_electionTopicData$2 = electionTopicData[0]) === null || _electionTopicData$2 === void 0 ? void 0 : _electionTopicData$2.headingImageUrl
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("i", {
                  className: "icon-play-circle",
                  width: "500px",
                  height: "500px",
                  style: {
                    color: "white",
                    position: "absolute",
                    left: "2px",
                    bottom: "-5px",
                    width: "500px"
                  }
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                className: "electionYatra-second-bottom",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h2", {
                  children: (_electionTopicData$3 = electionTopicData[0]) === null || _electionTopicData$3 === void 0 ? void 0 : _electionTopicData$3.title
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            },
            children: electionTopicData.slice(1).map(function (x, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
                href: "".concat(x === null || x === void 0 ? void 0 : x.permalink),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                  className: "electionYatra-first",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                    className: "electionYatra-first-div",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                      style: {
                        // flex: "0 0 38%",
                        position: "relative",
                        justifyContent: "center",
                        alignContent: "center",
                        alignItems: "center"
                      },
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                        src: x === null || x === void 0 ? void 0 : x.headingImageUrl,
                        width: "160px",
                        height: "90px"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("i", {
                        className: "icon-play-circle",
                        style: {
                          color: "white",
                          position: "absolute",
                          left: "2px",
                          bottom: "-5px"
                        }
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                      className: "electionYatra-first-div-right",
                      style: {
                        flex: "0 0 60%"
                      },
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                          style: {
                            overflow: "hidden"
                          },
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                            style: {
                              display: "-webkit-box",
                              lineHeight: "22px",
                              WebkitLineClamp: "3",
                              WebkitBoxOrient: "vertical",
                              marginTop: "5px"
                            },
                            className: "chunav-yatra-small-title",
                            children: x === null || x === void 0 ? void 0 : x.title
                          })
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                        style: {
                          display: "flex",
                          gap: "1rem"
                        }
                      })]
                    })]
                  })
                })
              }, index);
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
            style: {
              width: "100%"
            },
            className: "checkDesktopOrNot",
            href: "".concat((_electionTopicData$4 = electionTopicData[0]) === null || _electionTopicData$4 === void 0 ? void 0 : _electionTopicData$4.permalink),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
              className: "electionYatra-second election-desktop",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                className: "electionYatra-second-top",
                style: {
                  position: "relative"
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                  src: (_electionTopicData$5 = electionTopicData[0]) === null || _electionTopicData$5 === void 0 ? void 0 : _electionTopicData$5.headingImageUrl
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("i", {
                  className: "icon-play-circle",
                  width: "500px",
                  height: "500px",
                  style: {
                    color: "white",
                    position: "absolute",
                    left: "2px",
                    bottom: "-5px",
                    width: "500px"
                  }
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                className: "electionYatra-second-bottom",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h2", {
                  children: (_electionTopicData$6 = electionTopicData[0]) === null || _electionTopicData$6 === void 0 ? void 0 : _electionTopicData$6.title
                })
              })]
            })
          })]
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      align: "center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "container-row py-2",
        align: "center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
          style: {
            fontSize: "11px",
            color: "#b7b7b7",
            textAlign: "center",
            marginBottom: "0px"
          },
          children: "Advertisement"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          id: size.width > 600 ? "div-gpt-ad-1701945220410-1" : "div-gpt-ad-1701946028239-1",
          style: {
            minWidth: "300px",
            minHeight: size.width > 600 ? "100px" : "260px",
            display: "block !important",
            alignContent: "center",
            textAlign: "-webkit-center"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("script", {
            type: "text/javascript",
            dangerouslySetInnerHTML: {
              __html: size.width > 600 ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})"
            }
          })
        })]
      }), " "]
    })]
  });
}

/***/ }),

/***/ 69916:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/election/maharashtra-assembly-chunav/schedule",
      function () {
        return __webpack_require__(51253);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,532,2888,179], function() { return __webpack_exec__(69916); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);